import { FormContext } from '@sec-loans-ui/ifp-loans/steps/formContext'
import { FormStep } from '@sec-loans-ui/ifp-loans/steps/FormStep'
import { useWizardForm } from '@ui-common/hooks'
import { use } from 'react'

// TODO DIG-5781 - Actual Implementation
export const ConsentStep = () => {
  const { wizardData } = use(FormContext)

  const methods = useWizardForm({
    defaultValues: wizardData,
  })

  return (
    <FormStep
      allowBack={false}
      subHeader={'ConsentStep'}
      formMethods={methods}
      onSubmit={() => {
        return
      }}
    />
  )
}
